export const urls = {
	list: (query_string) => `/my/api/2/search/?query=${query_string}&count=10`
};